<template>
  <div class="ship">
    <el-dialog title="发货" :visible.sync="dialogVisible" width="1200px" :before-close="handleClose">
      <div class="main">
        <div class="goods">
          <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" border @selection-change="handleSelectionChange">
            <el-table-column align="center" type="selection" width="55" :selectable="checkboxT"></el-table-column>
            <el-table-column align="center" prop="title" label="商品名称" show-overflow-tooltip> </el-table-column>
            <el-table-column align="center" prop="sku_num" label="数量" width="80"> </el-table-column>
            <el-table-column align="center" prop="warehouse_address" label="发货地址">
              <template slot-scope="scope">
                <el-select v-if="scope.row.Addoptions" v-model="scope.row.ActiveAddress" placeholder="请选择" size="small" @change="AddressChange" :key="scope.row.spu_id">
                  <el-option v-for="item in scope.row.Addoptions" :key="item.id" :label="item.province + item.city + item.district + item.address" :value="item.id"> </el-option>
                </el-select>
                <div v-if="scope.row.Active == false && !scope.row.ActiveAddress" style="color:red">当前商品不可发货</div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="orders_deliveries" label="收货地址" show-overflow-tooltip>
              <template slot-scope="{ row }">
                <span v-if="row.orders_deliveries">
                  {{
                    `${row.orders_deliveries.receivers_provinces}
                    ${row.orders_deliveries.receivers_citys}*********` | isNull
                  }}<!-- ${row.orders_deliveries.receivers_districts} ${row.orders_deliveries.receivers_address} -->
                </span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="net_weight" label="商品重量" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{ row.net_weight.weight.weightValueName + weight || "-" }}
              </template>
            </el-table-column>
            <el-table-column align="center" prop="volume" label="商品体积长宽高" show-overflow-tooltip>
              <template slot-scope="{ row }">
                {{
                  row.net_weight.size.sizeLong.sizeValueName +
                    row.net_weight.size.sizeLong.sizeValueUnit +
                    "x" +
                    row.net_weight.size.sizeWide.sizeValueName +
                    row.net_weight.size.sizeWide.sizeValueUnit +
                    "x" +
                    row.net_weight.size.sizeHigh.sizeValueName +
                    row.net_weight.size.sizeHigh.sizeValueUnit || "-"
                }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="select_goods">
          <h3>物流公司</h3>
          <div class="flex" style="margin-bottom: 30px">
            <div class="flex" style="margin-right: 12px">
              <p style="margin-right: 12px">物流</p>
              <el-select v-model="type" placeholder="请选择" size="small" clearable @visible-change="VisibleChange" @change="ExpressChange">
                <el-option v-for="item in ExpressDelivery" :key="item.companyId" :label="item.companyName" :value="item.companyId">
                  {{ item.companyName }}
                  <span>预估运费{{ item.price ? item.price : "" }}</span>
                </el-option>
              </el-select>
            </div>
            <el-button type="warning" size="small" @click="operate('price')">预估运费</el-button>
            <el-button type="primary" size="small" @click="operate('ship')">确定发货</el-button>
          </div>
          <div class="table" v-if="isValuation">
            <el-table ref="multipleTable" :data="shipTableData" tooltip-effect="dark" style="width: 100%" border :span-method="cellMerge">
              <el-table-column align="center" prop="title" label="商品名称" show-overflow-tooltip> </el-table-column>
              <el-table-column align="center" prop="sku_num" label="数量"> </el-table-column>
              <el-table-column align="center" prop="logistics_company" label="物流公司">
                <template slot-scope="{ row }">
                  {{ row.logistics_company | isNull }}
                </template>
              </el-table-column>
              <el-table-column align="center" prop="freight" label="运费预估(元)">
                <template slot-scope="{ row }">
                  {{ row.freight | isNull }}
                </template>
              </el-table-column>
              <el-table-column align="center" prop="shipment_number" label="物流单号">
                <template slot-scope="{ row }">
                  {{ row.shipment_number | isNull }}
                </template>
              </el-table-column>
              <el-table-column align="center" prop="shipment_status" label="物流状态"> </el-table-column>
              <el-table-column align="center" prop="orders_deliveries" label="收货地址" show-overflow-tooltip>
                <template slot-scope="{ row }">
                  <span v-if="row.orders_deliveries">
                    {{
                      `${row.orders_deliveries.receivers_provinces}
                                            ${row.orders_deliveries.receivers_citys}******` | isNull
                    }}
                    <!-- ${row.orders_deliveries.receivers_districts} ${row.orders_deliveries.receivers_address} -->
                  </span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="create_time" label="创建时间" show-overflow-tooltip> </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" plain>关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      dialogVisible: false,

      //快递公司类型
      type: "",

      //完整订单列表数据
      shipTableData: [],

      // 待选商品数据
      tableData: [],

      // 已选商品数据
      multipleSelection: [],

      // 是否估价
      isValuation: false,

      // 订单编号
      orders_sn: "",
      orders_projects_id: "", //订单ID
      address_id: {
        address: "",
        id: ""
      }, //选择地址之后的ID
      addressString: "",
      // 合并行数据
      spanArr: [],
      pos: "",

      // 返回的数据
      result_price: "",
      result_express_no: "",
      options: [], //发货地址的数组
      ExpressDelivery: [], //物流的数组
      Invoice: {}, //确认发货操作所需字段
      OldVisibleChange: "",
      weight: "", //商品的重量单位
      volume: "", //商品的体积单位
      shopIDList: "", //店铺ID
      AddressAllList: [] //商品地址的总数组
    };
  },
  computed: {
    ...mapGetters(["getToken"])
  },
  props: {},
  filters: {
    strFmt(val) {
      if (val && val.length > 8) {
        return val.substring(0, 8) + "...";
      }
      return val || "-";
    },
    isNull(val) {
      return val || "-";
    }
  },
  watch: {
    "address_id.id": function(newData, oldData) {
      if (newData !== oldData) {
        this.isValuation = false;
        this.type = "";
        this.shipTableData = [];
        // this.options=[]
      }
    }
  },
  methods: {
    ...mapActions({
      getOrdersConsignmentsList: "commodity/getOrdersConsignmentsList",
      getExpressPrice: "commodity/getExpressPrice",
      consignmentsCreate: "commodity/consignmentsCreate",
      GetShopAddress: "commodity/GetShopAddress",
      ExpressDeliveryPric: "commodity/ExpressDeliveryPric",
      getBeiOrderDetails: "commodity/getBeiOrderDetails", //修改成为北京查询列表的详情接口
      getBeiOrderInfo: "commodity/getBeiOrderInfo", //
      getBeiOrdertoken: "commodity/getBeiOrdertoken",
      GetShopVolume: "commodity/GetShopVolume", //获取商品的体积以及重量
      InquireCashPledge: "commodity/InquireCashPledge", //获取当前账户押金
      ExpressAddress: "commodity/ExpressAddress", //获取订单的发胡仓
      GetExpressNoAddress: "commodity/GetExpressNoAddress" //获取快递公司的不可发货
    }),
    getAddress(ids) {
      let data = {
        goods_ids: ids.toString(),
        token: this.getToken
      };
      this.ExpressAddress(data).then(res => {
        if (res.code === 1) {
          this.AddressAllList = res.data;
          this.tableData.forEach(item => {
            item.Addoptions = [];
            item.ReceivingAddress =
              item.orders_deliveries.receivers_provinces + item.orders_deliveries.receivers_citys + item.orders_deliveries.receivers_districts + item.orders_deliveries.receivers_address;
            res.data.forEach(index => {
              if (item.spu_id === index.goods_id) {
                item.Addoptions = index.data;
              }
              index.data.forEach(index2 => {
                index2.destinationRelation.forEach(index3 => {
                  if (item.ReceivingAddress.indexOf(index3.province) !== -1) {
                    item.ActiveAddress = index2.id;
                  } else {
                    item.Active = false;
                  }
                });
              });
            });
          });
        }
        console.log("ids :>> ", this.tableData);
      });

      // this.GetShopAddress(this.getToken).then(res=>{
      //     if(res.code===1){
      //         this.options=res.data
      //     }else{
      //         this.$message.warning(res.msg);
      //     }
      // })
    },
    cellMerge({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 3 || columnIndex === 4) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        };
      }
    },
    AddressChange(val) {
      this.address_id.id = val;
    },
    ExpressChange(val) {
      if (val === "") {
        this.isValuation = false;
      }
      console.log("val :>> ", val);
      let addID = "";
      this.multipleSelection.forEach(index => {
        if (index.ActiveAddress === this.multipleSelection[0].ActiveAddress) {
          index.Addoptions.forEach(item => {
            if (this.multipleSelection[0].ActiveAddress == item.id) {
              addID = item.townCode ? item.townCode : item.districtCode ? item.districtCode : item.cityCode ? item.cityCode : item.districtCode;
            }
          });
        } else {
          return this.$message.error("发货地址选择不一致");
        }
      });
      let data = {
        code: addID,
        express_id: val,
        merchant_id: this.$getSessionStorage("userid")
      };
      this.GetExpressNoAddress(data).then(res => {
        if (res.code === 1) {
          this.operate("price");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    async VisibleChange(val) {
      if (val) {
        if (this.multipleSelection.length == 0) {
          return this.$message.warning("请先选择商品");
        }

        let ids = this.multipleSelection.map(item => {
          return item.id;
        });
        if (ids == "") {
          return this.$message.warning("请选择商品的发货地址");
        }
        let row = {};
        let addressid = this.multipleSelection[0].ActiveAddress;
        let bleen = false;
        await this.multipleSelection.forEach(index => {
          if (index.ActiveAddress === addressid) {
            bleen = true;
            index.Addoptions.forEach(item => {
              if (addressid == item.id) {
                row = item;
              }
            });
          } else {
            bleen = false;
            this.ExpressDelivery = [];
            return this.$message.error("发货地址选择不一致");
          }
        });
        if (bleen) {
          let params = {
            token: this.getToken,
            orders_sn: this.orders_projects_id.toString(),
            orders_goods_id: ids.toString(),
            warehouse_address_id: addressid.toString(),
            send_name: row.name, // 发货人姓名
            send_phone: row.phone, // 发货电话
            send_address: row.address, // 发货地址
            send_province: row.province, // 发货省份
            send_city: row.city, // 发货市
            send_district: row.town + row.district
          };
          this.ExpressDeliveryPric(params).then(res => {
            if (res.code === 1) {
              this.ExpressDelivery = res.data;
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      }
    },
    getSpanArr(data) {
      this.spanArr = [];
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0;
        } else {
          // 判断当前元素与上一个元素是否相同
          if (data[i].logistics_company === data[i - 1].logistics_company) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
      }
    },
    getNowTime() {
      let dateTime;
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      let hh = new Date().getHours();
      let mf = new Date().getMinutes() < 10 ? "0" + new Date().getMinutes() : new Date().getMinutes();
      let ss = new Date().getSeconds() < 10 ? "0" + new Date().getSeconds() : new Date().getSeconds();
      dateTime = yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;
      return dateTime;
    },
    optionchange(val) {},
    operate(typeStr) {
      if (this.multipleSelection.length == 0) {
        return this.$message.warning("请先选择商品");
      }
      if (this.type == "") {
        return this.$message.warning("请先选择物流公司");
      }

      let ids = this.multipleSelection.map(item => {
        return item.id;
      });
      if (ids == "") {
        return this.$message.warning("请选择商品的发货地址");
      }
      let row = {};
      // this.options.forEach(item => {
      //   if (item.id === this.address_id.id) {
      //     row = item;
      //   }
      // });
      let url;
      let expressName;
      this.ExpressDelivery.forEach(element => {
        if (element.companyId === this.type) {
          this.result_price = element.price;
          expressName = element.companyName;
        }
      });
      if (typeStr !== "price") {
        let shopIDList = JSON.parse(localStorage.getItem("shop")).shop;
        let row ={};
        this.multipleSelection[0].Addoptions.forEach(item => {
          if(this.multipleSelection[0].ActiveAddress==item.id){
              row = item
              console.log(row)
          }
        });
        let shop_id = ''
        /*  this.InquireCashPledge(data).then(res => {
                    if(res.code===1 && res.data.total_balance> this.result_price){ */
        url = this.consignmentsCreate;
        let params = {
          token: this.getToken,
          orders_sn: this.orders_projects_id,
          orders_goods_id: ids.toString(),
          express_id: this.type,
          // express_name:expressName,
          express_companys: expressName,
          appraised_price: this.result_price,
          send_name: row.name, // 发货人姓名
          send_phone: row.phone, // 发货电话
          send_address: row.address, // 发货地址
          send_province: row.province, // 发货省份
          send_city: row.city, // 发货市
          send_district: row.district // 发货区
        };
        url(params).then(res => {
          if (res.code == 1) {
            this.$message.success("发货成功！");
            if (typeStr !== "price") {
              this.result_express_no = res.data.express_no;
            }
          } else {
            this.$message.error(res.msg);
          }
        });
        /*  }else{
                        this.$message.error("当前账户的余额不足");
                    }
                }) */
      } else {
        this.isValuation = true;
        this.shipTableData = [];
        this.$nextTick(() => {
          let addrList = {};
          this.ExpressDelivery.forEach(item => {
            if (this.type === item.companyId) {
              addrList = item;
            }
          });
          this.multipleSelection.forEach(item => {
            let obj = {
              title: item.title,
              sku_num: item.sku_num,
              logistics_company: addrList.companyName,
              shipment_status: "揽件",
              // orders_deliveries: item.orders_deliveries,
              // let arr=res.data.receivers_provinces+res.data.receivers_citys+res.data.receivers_districts+res.data.receivers_address
              orders_deliveries: {
                receivers_provinces: item.orders_deliveries.receivers_provinces,
                receivers_citys: item.orders_deliveries.receivers_citys,
                receivers_districts: item.orders_deliveries.receivers_districts,
                receivers_address: item.orders_deliveries.receivers_address
              },
              create_time: this.getNowTime(),
              freight: this.result_price,
              shipment_number: this.result_express_no
            };
            this.shipTableData.push(obj);
          });
          this.getSpanArr(this.shipTableData);
          this.$message.success(typeStr == "price" ? "获取价格成功！" : "发货成功！");
        });
      }
    },
    async getList(item) {
      let data = {
        token: this.getToken
      };
      // await this.getBeiOrdertoken(data).then((res) => {
      //     localStorage.setItem("Beitoken",res.data.token)
      // });

      this.orders_sn = item.order_child_sn;
      let params = {
        id: item.id
      };
      this.getBeiOrderInfo(params).then(async res => {
        if (res.code === 0) {
          let paramsShop = {
            goods_id: res.data.goods[0].spu_id
          };
          let ids = res.data.goods
            .map(item => {
              return item.spu_id;
            })
            .toString();
          this.getAddress(ids);
          let size = {};
          if (res.data.goods[0].spu_id !== 0) {
            this.GetShopVolume(paramsShop).then(restad => {
              res.data.goods.forEach(item => {
                item.Addoptions = [];
                item.ActiveAddress = "";
                this.AddressAllList.forEach(index => {
                  if (item.spu_id === index.goods_id) {
                    item.Addoptions = index.data;
                  }
                });
                item.orders_deliveries = {};
                // let arr=res.data.receivers_provinces+res.data.receivers_citys+res.data.receivers_districts+res.data.receivers_address
                item.orders_deliveries.receivers_provinces = res.data.receivers_provinces;
                item.orders_deliveries.receivers_citys = res.data.receivers_citys;
                item.orders_deliveries.receivers_districts = res.data.receivers_districts;
                item.orders_deliveries.receivers_address = res.data.receivers_address;
                item.net_weight = restad.data;
              });
              this.tableData = res.data.goods;
              // if (this.options.length > 0) {
              //   this.options.forEach(item => {
              //     item.destinationRelation.forEach(elent => {
              //       if (elent == res.data.receivers_citys) {
              //         this.address_id.id = item.id;
              //       }
              //     });
              //   });
              // }
              this.Invoice = res.data;
              this.orders_projects_id = item.id;
            });
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    checkboxT(row) {
      if (row.refunds_status == 2 || row.refunds_status == 3) {
        return false; //禁用
      } else {
        return true; //不禁用
      }
    },
    handleClose() {
      this.dialogVisible = false;
      this.multipleSelection = [];
      this.shipTableData = [];
      this.address_id = {};
      this.type = "";
      this.isValuation = false;
      this.orders_sn = "";
      this.orders_projects_id = "";
    },
    handleSelectionChange(val) {
      console.log("val :>> ", val);
      this.multipleSelection = val;
    }
  }
};
</script>

<style lang="scss" scoped>
.ship {
  .main {
    height: 520px;
    overflow-y: auto;
    &::-webkit-scrollbar-track-piece {
      background: #d3dce6;
    }

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background: #99a9bf;
      border-radius: 20px;
    }
  }
  .select_goods {
    h3 {
      margin: 30px 0;
    }
  }
  .flex {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  ::v-deep .el-dialog__header {
    border-bottom: 1px solid #e8e8e8;
  }
}
::v-deep .el-table__body-wrapper {
  max-height: 400px;
  overflow-y: auto;
}
</style>
